import { Button, DatePicker, Form, Input, message, Modal, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { API } from "../../../config/Api";
import { GET, POST } from "../../../utils/apiRequest";
import { FindDateRange } from "../../../utils/dateRange";
import dayjs from "dayjs";

const RenewSubscriptionModal = (props: any) => {
  const User = useSelector((state: any) => state?.User?.user);
  const [isLoading, setloading] = useState(false);
  const [selectedSub, setSelectedSub] = useState<any>(null);
  const [duration, setDuration] = useState<any>(null);
  const [durationType, setDurationType] = useState<any>(null);
  const [start_date, setStart_date] = useState<any>(null);
  const [end_date, setEnd_date] = useState<any>(null);
  const [price_amount, setPriceAmount] = useState<number>(0);
  const [subscription, setSubscription] = useState<any>([]);
  const [tokens, setTokens] = useState([]); 
  const [selectedTok, setSelectedTok] = useState<any>(null);
  const [tokenCount, setTokenCount] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState<string | null>(
    "subscription"
  );

  const [form] = Form.useForm();

  const getTokens = async (pageNum: number) => {
    try {
      let api = `${API.LIST_TOKEN}?order=DESC&page=${pageNum}&take=500`;
      let payload = { office_id: User?.office?.id, is_token: true };
      const details: any = await POST(api, payload);
      if (details?.status) {
        setTokens(details.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onFinish = async (val: any) => {
    try {
      setloading(true);
      const url = API.RENEW_SUB;

      let formattedStartDate = null;
      let formattedEndDate = null;

      if (start_date && dayjs(start_date).isValid()) {
        formattedStartDate = dayjs(start_date).format("YYYY-MM-DD");
      } else if (val?.startDate && dayjs(val.startDate).isValid()) {
        formattedStartDate = dayjs(val.startDate).format("YYYY-MM-DD");
      }

      if (end_date && dayjs(end_date).isValid()) {
        formattedEndDate = dayjs(end_date).format("YYYY-MM-DD");
      } else if (val?.endDate && dayjs(val.endDate).isValid()) {
        formattedEndDate = dayjs(val.endDate).format("YYYY-MM-DD");
      }

      if (!formattedStartDate || !formattedEndDate) {
        const currentDate = dayjs();
        formattedStartDate =
          formattedStartDate || currentDate.format("YYYY-MM-DD");

        if (duration && durationType) {
          formattedEndDate = currentDate
            .add(duration, durationType)
            .format("YYYY-MM-DD");
        } else {
          formattedEndDate = currentDate.add(30, "days").format("YYYY-MM-DD");
        }
      }

      const discountValue = val?.discount || 0;

      let obj = {
        plan_id: selectedSub?.id ?? selectedTok?.id,
        office_id: props?.data?.office_id,
        user_id: props?.data?.id,
        user_type: props?.data?.type,
        discount: discountValue,
        disc_type: val?.discount_type || "amount",
        plan_type: val?.plan_type,
        ...(val?.plan_type === "token" ? { token_count: val?.tokenCount } : {}),
        subscription_name:
          val?.plan_type === "token" ? selectedTok?.name : selectedSub?.name,
        paid_amount: String(val?.paided_amount),
        payment_method: val?.paymentMethod,
        comment: val?.comment || "",
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        by:
          `${User?.user?.first_name || ""} ${User?.user?.last_name || ""}`.trim() ||
          "System",
      };

  

      const response: any = await POST(url, obj);
      if (response?.status) {
        message.success(`Successfully renew ${val?.plan_type}`);
        let transaction = response?.data?.transaction;
        let messageText = `Hello ${props?.data?.first_name},
  
        \nYour subscription to ${selectedSub?.name} was successfully renewed and will expire on ${moment(formattedEndDate).format("DD MMM YYYY")}.
  
        \nAmount ${price_amount}
        \nPaid ${val?.paided_amount} 
        \nBalance ${price_amount - val?.paided_amount}
  
        \nThank you 
  
        \n\nPlease find your invoice here: https://xentrybook.com/invoice/${transaction?.transaction_id}
  
        \n\n${props?.data?.office_name}
        \n${User?.office?.address}
        \n${User?.office?.phone}`;

        let whatsappUrl = `https://wa.me/${props?.data?.mobile_number}?text=${encodeURIComponent(messageText)}`;
        window.open(whatsappUrl, "_blank");

        props?.reload();
        props?.handleCancel();
      } else {
        message.error(response?.message || `Failed to renew ${val?.plan_type}`);
        setloading(false);
      }
    } catch (error) {
      setloading(false);
      console.log(error);
    } finally {
      setloading(false);
    }
  };

  const handleSubscriptionChange = async (value: any, option: any) => {
    try {
      if (selectedPlan === "subscription") {
        setSelectedSub(option);
      } else {
        setSelectedTok(option);
      }
      const { duration_type, duration, price } = option;
      setPriceAmount(price);
      form.setFieldsValue({ paid_amount: price });
      form.setFieldsValue({ price_per_token: price });

      setDuration(duration);
      setDurationType(duration_type);

      const ranges: any = await FindDateRange(duration_type, duration);

      // Convert moment objects to dayjs objects
      const startDate = dayjs(ranges.start);
      const endDate = dayjs(ranges.end);
      
      setStart_date(startDate);
      setEnd_date(endDate);

      form.setFieldsValue({
        startDate: startDate,
        endDate: endDate,
      });
    } catch (err) {
      console.error("Error selecting subscription:", err);
    }
  };

  const ChangeSubDate = (start: any, end: any, type: any) => {
    try {
      if (!start || !end) {
        setStart_date(null);
        setEnd_date(null);
        return;
      }
      setStart_date(start);
      setEnd_date(end);
      const duro = duration || 0;
      if (type === 1) {
        let endDate = dayjs(start).add(duro, durationType);
        setEnd_date(endDate);
        form.setFieldsValue({ endDate: endDate });
      } else {
        let startDate = dayjs(end).subtract(duro, durationType);
        setStart_date(startDate);
        form.setFieldsValue({ startDate: startDate });
      }
    } catch (err) {
      console.log("Error in ChangeSubDate:", err);
    }
  };
  const getDetails = async () => {
    try {
      const details: any = await GET(
        `${API.SUBCRIPTION_OFFICE}${User?.office?.id}`,
        {}
      );
      if (details?.status) {
        setSubscription(details?.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  useEffect(() => {
    getDetails();
    getTokens(1);
  }, []);

  // Reset form when modal opens/closes
  useEffect(() => {
    if (props.isModalOpen) {
      // Reset form and state when modal opens
      form.resetFields();
      setSelectedSub(null);
      setSelectedTok(null);
      setPriceAmount(0);
      setDuration(null);
      setDurationType(null);
      setStart_date(null);
      setEnd_date(null);
      setTokenCount(1);
      
      // Set initial values
      form.setFieldsValue({
        plan_type: "subscription",
        discount_type: "amount",
        startDate: null,
        endDate: null,
        paid_amount: 0,
        paided_amount: 0,
      });
    }
  }, [props.isModalOpen]);

  useEffect(() => {
    form.setFieldsValue({
      paid_amount: tokenCount > 1 ? price_amount * tokenCount : price_amount,
    });
  }, [price_amount, form, tokenCount]);

  const calculateFinalAmount = (
    discountType: string,
    discount: number,
    baseAmount: number
  ) => {
    let totalAmount = baseAmount;
    if (selectedPlan === "token") {
      totalAmount = baseAmount * tokenCount;
    }
    let finalAmount = totalAmount;
    if (discountType === "amount") {
      finalAmount = Math.max(0, totalAmount - discount);
    } else if (discountType === "percentage") {
      finalAmount = Math.max(0, totalAmount - (totalAmount * discount) / 100);
    }
    form.setFieldsValue({ paid_amount: finalAmount.toFixed(2) });
  };
  const onPlanChange = async (val: any) => {
    try {
      setSelectedPlan(val);
      setSelectedSub(null);
      setSelectedTok(null);
      setPriceAmount(0);
      setDuration(null);
      setDurationType(null);
      
      // Clear dates when plan type changes
      setStart_date(null);
      setEnd_date(null);

      form.setFieldsValue({
        subscription: undefined,
        token: undefined,
        paid_amount: 0,
        discount: undefined,
        discount_type: "amount",
        startDate: null,
        endDate: null,
      });
    } catch (err) {
      console.log("Error in onPlanChange:", err);
    }
  };
  const onValuesChange = (val: any, data: any) => {
    if (val?.discount || val.discount === "") {
      if (data.discount_type === "amount") {
        let amount;
        if (data.plan_type === "token") {
          amount = price_amount * data.tokenCount - Number(val?.discount);
        } else {
          amount = price_amount - Number(val?.discount);
        }
        form.setFieldsValue({ paid_amount: amount });
        form.setFieldsValue({ paided_amount: amount });
      } else {
        let perAmount;
        if (data.plan_type === "token") {
          perAmount =
            price_amount * data.tokenCount -
            (price_amount * data.tokenCount * Number(val?.discount)) / 100;
        } else {
          perAmount =
            price_amount - (price_amount * Number(val?.discount)) / 100;
        }
        const amount =
          price_amount * data.tokenCount -
          (price_amount * data.tokenCount * Number(val?.discount)) / 100;
        form.setFieldsValue({ paid_amount: perAmount });
        form.setFieldsValue({ paided_amount: perAmount });
      }
    }
    if (val.tokenCount) {
      const amountCount = price_amount * val.tokenCount;
      form.setFieldsValue({ paid_amount: amountCount });
      form.setFieldsValue({ paided_amount: amountCount });
    }
  };
  useEffect(() => {
    const paidAmount =
      tokenCount > 1 ? price_amount * tokenCount : price_amount;
    form.setFieldsValue({
      paid_amount: paidAmount,
      paided_amount: paidAmount, // Set default value for paided_amount
    });
  }, [price_amount, form, tokenCount]);
  return (
    <div>
      <Modal
        open={props.isModalOpen}
        onOk={props.isModalOpen}
        onCancel={props.handleCancel}
        footer={false}
        closeIcon={false}
        centered
      >
        <h5 className="user-heading">
          Renew Subscription ({props?.data?.admisson_id})
        </h5>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark
          onValuesChange={onValuesChange}
        >
          <Row>
            <Col md={6}>
              <Form.Item
                name="plan_type"
                label="Plan Type"
                initialValue="subscription"
              >
                <Select
                  placeholder="Choose Plan Type"
                  optionFilterProp="label"
                  onChange={(value) => onPlanChange(value)}
                  options={[
                    { value: "subscription", label: "Subscription" },
                    { value: "token", label: "Token" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col md={6}>
              {selectedPlan === "subscription" ? (
                <Form.Item name="subscription" label="Subscription Plan">
                  <Select
                    placeholder="Choose a Subscription Plan"
                    onChange={handleSubscriptionChange}
                    allowClear
                  >
                    {subscription?.map((item: any) => (
                      <Select.Option
                        key={item?.id}
                        id={item?.id}
                        name={item?.name}
                        price={item?.price}
                        duration_type={item?.duration_type}
                        duration={item?.duration}
                      >
                        {item.name} - {item.duration} {item.duration_type} - ₹
                        {item.price}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              ) : (
                <Form.Item name="token" label="Token Plan">
                  <Select
                    placeholder="Choose a Token Plan"
                    onChange={handleSubscriptionChange}
                    allowClear
                  >
                    {tokens?.map((item: any) => (
                      <Select.Option
                        key={item?.id}
                        id={item?.id}
                        name={item?.name}
                        price={item?.price}
                        duration_type={item?.duration_type}
                        duration={item?.duration}
                      >
                        {item.name} - {item.duration} {item.duration_type} - ₹
                        {item.price}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            {selectedPlan === "token" && (
              <Col md={6}>
                <Form.Item initialValue={1} label="Count" name="tokenCount">
                  <Input min={1} type="number" />
                </Form.Item>
              </Col>
            )}
            {selectedPlan === "token" && (
              <Col md={6}>
                <Form.Item label="Price Per Token" name="price_per_token">
                  <Input disabled />
                </Form.Item>
              </Col>
            )}

            <Col md={6}>
              <Form.Item
                name="discount_type"
                label="Discount Type"
                initialValue="amount"
              >
                <Select
                  placeholder="Choose Discount Type"
                  optionFilterProp="label"
                  options={[
                    { value: "amount", label: "Amount" },
                    { value: "percentage", label: "Percentage" },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col md={6}>
              <Form.Item label="Discount" name="discount">
                <Input type="number" min={0} />
              </Form.Item>
            </Col>

            <Col md={6}>
              <Form.Item label="Amount" name="paid_amount">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item
                label="Paid Amount"
                name="paided_amount"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const maxValue = getFieldValue("paid_amount");
                      if (value === undefined || value === null)
                        return Promise.resolve();
                      if (value > maxValue) {
                        return Promise.reject(
                          `Paid amount cannot exceed ${maxValue}`
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  type="number"
                  min={0}
                  onChange={(e) => {
                    const maxValue = form.getFieldValue("paid_amount");
                    let inputValue = Number(e.target.value);
                    if (inputValue > maxValue) {
                      form.setFieldsValue({ paided_amount: maxValue });
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col md={6}>
              <Form.Item name="startDate" label="Start Date">
                <DatePicker
                  style={{ width: "100%" }}
                  value={
                    start_date && dayjs(start_date).isValid()
                      ? dayjs(start_date)
                      : null
                  }
                  onChange={(value) => {
                    if (value && dayjs(value).isValid()) {
                      setStart_date(value);
                      form.setFieldsValue({ startDate: value });
                      
                      // Automatically calculate end date based on duration and duration type
                      if (duration && durationType) {
                        const calculatedEndDate = dayjs(value).add(duration, durationType);
                        setEnd_date(calculatedEndDate);
                        form.setFieldsValue({ endDate: calculatedEndDate });
                      }
                    } else {
                      setStart_date(null);
                      form.setFieldsValue({ startDate: null });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item name="endDate" label="End Date">
                <DatePicker
                  style={{ width: "100%" }}
                  value={
                    end_date && dayjs(end_date).isValid()
                      ? dayjs(end_date)
                      : null
                  }
                  onChange={(value) => {
                    if (value && dayjs(value).isValid()) {
                      setEnd_date(value);
                      form.setFieldsValue({ endDate: value });

                      // Automatically calculate start date based on duration and duration type
                      if (duration && durationType) {
                        const calculatedStartDate = dayjs(value).subtract(duration, durationType);
                        setStart_date(calculatedStartDate);
                        form.setFieldsValue({ startDate: calculatedStartDate });
                      }
                    } else {
                      setEnd_date(null);
                      form.setFieldsValue({ endDate: null });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item
                name="paymentMethod"
                label="Payment Method"
                rules={[
                  {
                    required: !!(selectedSub || selectedTok),
                    message: "Please select a payment method",
                  },
                ]}
              >
                <Select
                  placeholder="Choose Payment Method"
                  showSearch
                  allowClear
                >
                  {["BANK", "UPI", "CARD", "CASH"].map((method, idx) => (
                    <Select.Option value={method} key={idx}>
                      {method}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="comment" name="comment">
            <Input placeholder="New Plan Update etcc..." />
          </Form.Item>
          <Row>
            <Col md={5}></Col>
            <Col md={7}>
              <div className="d-flex gap-2">
                <Button block onClick={() => props?.handleCancel()}>
                  Close
                </Button>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                >
                  Update Now
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default RenewSubscriptionModal;
